import { el } from 'date-fns/locale';
import { forwardRef, ReactNode, useImperativeHandle, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

type Props = {
  title: string;
  subtitle: string;
  classes?: string;
  actionEnable?: any;
  actionDisable?: any;
  hideSwitch?: boolean;
  switchReplacementText?: string
  switchReplacementTextColor?: string
  icon?: ReactNode;
  tone?: 'default' | 'danger';

};

export const ManageDevicesAction = forwardRef((props: Props, ref) => {
  useImperativeHandle(ref, () => ({
    action,
    setAction,
  }));
  const [action, setAction] = useState(false);

  function handleChangeAction(checked: any) {
    setAction(checked);

    if (checked && props.actionEnable) {
      props.actionEnable();
    } else if (!checked && props.actionDisable) {
      props.actionDisable();
    }
  }

  const tone = props.tone ?? 'default';

  return (
    <div className={`dd-manage-action ${tone === 'danger' ? 'danger' : ''} ${action ? 'on' : ''} ${props.classes ?? ''}`}>
      {props.icon ? <span className="dd-manage-action-icon" aria-hidden="true">{props.icon}</span> : null}
      <div className="dd-manage-action-text">
        <span className="bd-h3 dd-manage-action-title">{props.title}</span>
        <span className="bd-meta dd-manage-action-sub">{props.subtitle}</span>
      </div>
      <div className="dd-manage-action-control">
        {props?.hideSwitch ? (
          <span className={`bd-chip ${props?.switchReplacementTextColor ?? ''}`}>
            <span className="dot" />
            <span className="bd-mono">{props?.switchReplacementText}</span>
          </span>
        ) : (
          <button
            type="button"
            role="switch"
            aria-checked={action}
            aria-label={props.title}
            className={`bd-switch ${action ? 'on' : ''}`}
            onClick={() => handleChangeAction(!action)}
          />
        )}
      </div>
    </div>
  );
});
